<template>
    <el-footer>

    </el-footer>
    
</template>

<script>


export default ({
    methods: {
        home(){
            this.$router.push('/');
        }
    }
})
</script>